<template>
  <div style="background-color: #f5f6f8">
    <div class="inner" style="padding: 10px 0;margin-bottom: 90px">
      <div id="photo-wrapper" data-v-1523d6cc="" ><!---->
        <div class="info_wrap" data-v-1523d6cc="">

          <aside id="photo__detail" class="photo-width" data-v-1523d6cc="">
            <div class="buy_info_wrap" data-v-1523d6cc="">
              <div class="title-text" data-v-1523d6cc=""></div>
              <div class="auth-range" data-v-1523d6cc="">图片编号：<span>{{data.VAttachmentNumber}}</span></div>
              <div class="auth-range" data-v-1523d6cc="">所属类别：<span >{{data.categoryname}}</span></div>
              <div class="auth-range" data-v-1523d6cc=""><span style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 6;
               overflow: hidden;":title="data.VAttachmentContent">图片简介：{{data.VAttachmentContent == '' ? '---' : data.VAttachmentContent}}</span></div>
              <div class="auth-range" data-v-1523d6cc="">图关键词：<span>{{data.keyrord == '' ? '---' : data.keyrord}}</span></div>
              <!--            <div class="auth-range" data-v-1523d6cc="">拍摄人：<span>{{data.author}}</span></div>-->
              <div class="auth-range" data-v-1523d6cc="">拍摄地点：<span>{{data.place == '' ? '---' : data.place}}</span></div>
              <div class="auth-range" data-v-1523d6cc="">拍摄日期：<span>{{data.Filmlocations == '' ? '---' : data.Filmlocations}}</span></div>
              <div class="auth-range" data-v-1523d6cc="">图分辨率：<span>{{fenbianlu}}</span></div>
              <div class="auth-range" data-v-1523d6cc="">图片大小：<span>{{data.DAttachmentSize}}</span></div>

            </div>
            <div class="about_use" data-v-1523d6cc="" id="lianxifangshi">
              <p class="mediaId" data-v-1523d6cc="" > 联系我们</p>
              <p class="m0 about_use_desc" data-v-1523d6cc=""><span data-v-1523d6cc="">联&ensp;系&ensp;人：{{lianxiren}}</span></p>
              <p class="m0 about_use_desc" data-v-1523d6cc=""><span data-v-1523d6cc="">联系方式：{{lianxidianhua}}</span></p>

            </div>
            <div class="about_use" data-v-1523d6cc="" >
              <p class="mediaId" data-v-1523d6cc=""> 版权说明</p>
              <p class="m0 about_use_desc" data-v-1523d6cc="" style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3;overflow: hidden;">
                <span data-v-1523d6cc="">{{banquanremark}}</span></p>
            </div>
          </aside>
          <div class="photo-preview" data-v-3327522a="" data-v-1523d6cc="">
            <div class="title-wrapper" data-v-3327522a="">
              <h2 class="suffix-title" :title="data.VAttachmentName" data-v-3327522a="" >{{data.VAttachmentName}} </h2></div>
            <div class="author-text" data-v-3327522a="" style="user-select: text"> 拍摄者：<span data-v-3327522a="" style="user-select: text">{{data.author == '' ? '---' : data.author}}</span></div>
            <div class="img-wrapper" data-v-3327522a="">
              <div  class="mask" v-if="show">
                正在加载图片中，请稍后
              </div>
<!--              <div v-if="!show" v-on:contextmenu.prevent="handleRightClick">-->
              <div v-if="!show" style="text-align: center; background: #f2f3f4;height: 100%;width: 100%;display: flex;
                      align-items: center;justify-content: center;">
                <img class="img-preview" draggable="false" :src="imageUrl" data-v-3327522a="">
              </div>
            </div>
            <div class="btn-wrapper" data-v-3327522a="">
              <div class="report-btn" data-v-3327522a="">
                下载量 {{data.downloadtime}}
              </div>
              <div class="action-btn" data-v-3327522a="">
                <el-button size="mini"  icon="el-icon-star-on" style="margin:10px;border-radius: 4px !important;background: #f2f3f4;color: cadetblue" v-if="favorite" @click="collectImg(false)">已收藏</el-button>
                <el-button size="mini"  icon="el-icon-star-off" style="margin:10px;border-radius: 4px !important;background: #f2f3f4;color: cadetblue" v-else @click="collectImg(true)">收藏</el-button>

                <el-button  size="mini" icon="el-icon-download" @click="downloadImg()" style="margin:10px;border-radius: 4px !important;background: #f2f3f4;color: cadetblue">试用下载</el-button>

<!--                <div title="试用下载" class="btn" data-v-3327522a="" @click="downloadImg()"> 试用下载</div>-->
              </div>
            </div><!----></div>
        </div>
      </div>

      <a id="linkUrl" href=""></a>
      <correlation-image></correlation-image>
    </div>
  </div>

</template>

<script>
import { jump, getUser } from "../../../../untils/auth.js";
import CorrelationImage from "./correlationImage";


  export default {
    name: "imageDetails",
    components: {CorrelationImage},
    data() {
      return {
        show: false, // 控制遮罩层的显示与隐藏
        imageUrl: '',
        data: [],
        lianxiren: '',
        lianxidianhua: '',
        banquanremark: '',
        VAttachmentName:'',
        fenbianlu:'',
        VAttachmentNumber:'',
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        favorite:false,
      };
    },


    created() {
      this.VProductId = this.$route.query.VProductId;
      console.log(this.VProductId)
      // this.current = this.$route.query.current;
      // this.searchtext = this.$route.query.searchtext;
      // this.categoryid = this.$route.query.categoryid;

      this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=lianxiren").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
                this.lianxiren =res.data.obj[0].VName
            }
          }
        }
      });
      this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=lianxidianhua").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              console.log(res.data.obj[0].VName)
              if (res.data.obj[0].VName.indexOf("/")>-1){
                var lianxi = res.data.obj[0].VName.split("/");
                this.lianxidianhua =lianxi[0];

                var mydiv = document.getElementById("lianxifangshi");//目标元素
                var children2 = mydiv.children[2];
                var node = children2.cloneNode(true)
                console.log(node.children[0].innerText)
                node.children[0].innerHTML="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+lianxi[1];
                mydiv.appendChild(node)
              }else{
                this.lianxidianhua =res.data.obj[0].VName
              }

            }
          }
        }
      });


      this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=banquanremark").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              console.log(res.data.obj[0].VName)
                this.banquanremark =res.data.obj[0].remark
            }
          }
        }
      });

      if (getUser()) {
        var data = {
          "createdBy": JSON.parse(getUser()).principal.VUserId,
          "VAttachmentId": this.VProductId
        };
        this.axios.post(window.IPConfig.IP + "/tBPrivateCollect/selectByVAttachmentId.do", data).then(res => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              this.favorite = true;
            } else {
              this.favorite = false;
            }
          }
        })
      }

      this.getList();
    },

    methods: {
      jump,


/*      copyName() {
        //参数是复制的内容
        //.then()中的函数是复制成功和复制失败的两个回调函数
        this.$copyText(this.VAttachmentName).then(
          (e) => {
            this.$message.success("复制成功!!");
          },
          (err) => {
            this.$message.error("复制失败");
          }
        );
      },*/
/*      copyNumber() {
        //参数是复制的内容
        //.then()中的函数是复制成功和复制失败的两个回调函数
        this.$copyText(this.VAttachmentNumber).then(
          (e) => {
            this.$message.success("复制成功!!");
          },
          (err) => {
            this.$message.error("复制失败");
          }
        );
      },*/


      // 获取图片详细信息
      getList() {
        this.axios.post(window.IPConfig.IP + "/tBAttachments/getByIdQian.do?VAttachmentId="+this.VProductId).then(res => {
          this.data = res.data.obj;
          this.imageUrl = res.data.obj.watermarkImage;
          this.VAttachmentName = res.data.obj.VAttachmentName;
          this.VAttachmentNumber = res.data.obj.VAttachmentNumber;
          if (this.imageUrl ==null||this.imageUrl==''){
            this.show=true;
            this.getImage();
          }
          if (res.data.obj.Filmlocations !=null){
            this.data.Filmlocations = this.formattedTime(res.data.obj.Filmlocations);
          }

          if (res.data.obj.imagewidth !=null){
            this.fenbianlu = res.data.obj.imagewidth+"x"+res.data.obj.imageheight+"px"
          }
          if (res.data.obj.DAttachmentSize!=null){
            if (res.data.obj.DAttachmentSize==0){
              this.data.DAttachmentSize="---";
            }else{
              this.data.DAttachmentSize=this.getFileSize(res.data.obj.DAttachmentSize);
            }

          }
        })
      },



      formattedTime(datestr) {
        console.log(datestr);
        const date = new Date(datestr);
        const year = date.getFullYear();
        if (isNaN(year)){
          return datestr;
        }
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      },


      getFileSize(size) {
          var data = (size / (1024 * 1024)).toFixed(2) + "MB";
          var sizestr = data + "";
          var len = sizestr.indexOf("\.");
          var dec = sizestr.substr(len + 1, 2);
          if (dec == "00") {//当小数点后为00时 去掉小数部分
            return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
          }
          return sizestr;
      },


// 获取图片详细信息
      getImage() {

        this.axios.post(window.IPConfig.IP + "/tBAttachments/getWaterImage.do?VAttachmentId="+this.VProductId).then(res => {
          console.log(res.data)
            if (res.data.status == 200) {
              this.show=false;
              this.imageUrl =res.data.url+ res.data.obj;
            }else{
              this.$message.error('图片预览失败!');
            }
        })
      },
      // 返回上一级页面
/*      goBack(){
        this.$router.push(
          {
            path: './pictureShare',
            query: {
              current: this.current,
              searchtext: this.searchtext,
              categoryid: this.categoryid,
            }
          }
        )
      },*/

      downloadImg(){
        if (getUser()) {
          var createdBy = getUser() == undefined ? '--' : JSON.parse(getUser()).principal.VUserId;
          let link = document.getElementById('linkUrl')
          link.href = window.IPConfig.IP + '/tBAttachments/downloadImg?VAttachmentId=' + this.$route.query.VProductId + "&createdBy=" + createdBy
          link.click()
        }else{
          this.jump("/login")
        }
      },

      collectImg(flag){
        if(getUser()) {
          this.axios.post(window.IPConfig.IP +'/tBPrivateCollect/add.do',{
              createdBy: JSON.parse(getUser()).principal.VUserId,
              VAttachmentId: this.VProductId
            }).then(res => {
            console.log(res)
            if (res.status == 200) {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg)
                this.favorite = flag
              } else {
                this.$message.error(res.data.msg)
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          this.jump('/login')
        }
      },

      handleRightClick:function (event) {
        this.$message.warning('图片受版权限制!');
      }
    }
  };
</script>

<style lang="stylus" scoped>
.el-container.is-vertical{
  background-color:#f5f6f8 !important
}

.mask {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  z-index: 9999;
  pointer-events: none;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
  color: #fff;
}


#photo-wrapper[data-v-1523d6cc] {
  position: relative;
  background-color: #f5f6f8
}


.photo-expansion[data-v-1523d6cc] {
  position: relative;
  margin: 16px auto 0;
  z-index: 1;
  padding-bottom: 50px
}

.info_wrap[data-v-1523d6cc] {
  min-height: 715px;
  display: flex;
  //margin: 26px auto 0
}

#photo__detail[data-v-1523d6cc] {
  padding-right: 0;
  box-sizing: border-box;
  width: 35%;
  margin-right: 20px;

}

#photo__detail .buy_info_wrap[data-v-1523d6cc] {
  background: #fff;
  position: relative;
  padding: 15px 35px
  height :400px;
}

#photo__detail .title-text[data-v-1523d6cc] {
  font-size: 22px;
  font-weight: 600;
  color: #000;
  line-height: 30px;
  user-select:text;
}

#photo__detail .auth-range[data-v-1523d6cc] {
  font-size: 14px;
  font-weight: 400;
  color: #656565;
  line-height: 20px;
  margin: 12px 0 20px;
  user-select:text;
}

#photo__detail .auth-range span {
  user-select:text;
}
#photo__detail .vip_buy_wrap[data-v-1523d6cc] {
  margin-top: 10px;
  padding: 28px 35px 26px;
  background: #fff
}

#photo__detail .vip_buy_wrap .vip-download-banner[data-v-1523d6cc] {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin-top: 24px;
  background: linear-gradient(180deg,#fff0d7,#ffd884);
  font-size: 20px;
  font-weight: 600;
  color: #864520;
  border-radius: 6px;
  cursor: pointer;
  text-align: center
}

#photo__detail .vip_buy_wrap .vip-download-banner[data-v-1523d6cc]:hover {
  opacity: .9!important
}

#photo__detail .about_use[data-v-1523d6cc] {
  font-size: 12px;
  color: #666;
  line-height: 20px;
  position: relative;
  background: #fff;
  padding: 22px 35px 20px;
  margin-top: 10px;
  height:150px
}

#photo__detail .about_use .mediaId[data-v-1523d6cc] {
  margin-bottom: 9px;
  font-size: 14px;
  font-weight: 400;
  color: #2a2a2a;
  line-height: 20px
}

#photo__detail .about_use .m0[data-v-1523d6cc] {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #999;
  line-height: 20px
}

#photo__detail .about_use .about_use_desc[data-v-1523d6cc] {
  display: flex;
  align-items: center;
  position: relative;
  user-select: text
}

#photo__detail .about_use .about_use_desc span {
  user-select:text
}

#photo__detail .func[data-v-1523d6cc] {
  margin-top: 17px;
  display: flex
}

#photo__detail .func .func-item[data-v-1523d6cc] {
  white-space: nowrap;
  padding: 6px 13px;
  background: #fff;
  border-radius: 4px;
  outline: 1px solid #ededed;
  font-size: 14px;
  font-weight: 400;
  color: #999;
  line-height: 20px;
  margin-right: 10px;
  cursor: pointer
}

#photo__detail .func .func-item[data-v-1523d6cc]:last-child {
  margin-right: 0
}

#photo__detail .func .func-item[data-v-1523d6cc]:hover {
  color: #666
}

.pic_button[data-v-1523d6cc] {
  letter-spacing: 1px
}

.photo-width[data-v-1523d6cc] {
  max-width: 97%
}

.sizeLi[data-v-1523d6cc] {
  background: #f5f6f8;
  margin-bottom: 19px
}

.sizeLi[data-v-1523d6cc]:hover {
  background: rgba(170,190,220,.1)
}

.sizeLi .select[data-v-1523d6cc] {
  width: 25px;
  height: 25px;
  background: #fff;
  border-radius: 50%;
  margin-left: 20px;
  flex-shrink: 0;
  border: 2px solid #979797
}

.sizeLi .act[data-v-1523d6cc] {
  background: #fe024b;
  position: relative;
  border: 2px solid #fe024b
}

.sizeLi .act[data-v-1523d6cc]:before {
  display: block;
  content: " ";
  position: absolute;
  width: 14px;
  height: 11px;
  top: 5px;
  right: 4px;
  background-image: url(https://static.paixin.com/paixin-ssr/client/static/images/selected.603243d8.svg);
  background-size: cover
}

.info-middle[data-v-1523d6cc] {
  height: 66px;
  display: flex;
  align-items: center;
  color: #000;
  font-size: 14px;
  font-weight: 600
}

.info-middle .item-info[data-v-1523d6cc] {
  flex-grow: 1;
  display: flex;
  align-items: center
}

.info-middle .item-info .item-type[data-v-1523d6cc] {
  width: 40px;
  height: 19px;
  margin-left: 12px;
  line-height: 19px;
  text-align: center;
  border-radius: 6px;
  color: #fff;
  background-color: #000;
  flex-shrink: 0
}

.info-middle .item-info .item-video-type[data-v-1523d6cc] {
  width: 60px;
  margin-left: 32px;
  font-size: 16px
}

.info-middle .item-info .item-desc[data-v-1523d6cc] {
  margin-left: 32px
}

.info-middle .item-info .item-px[data-v-1523d6cc] {
  flex-grow: 1;
  margin-left: 15px
}

.info-middle .item-info .item-dpi[data-v-1523d6cc] {
  width: 180px;
  font-weight: 400
}

.info-middle .item-info .item-price[data-v-1523d6cc] {
  margin-right: 29px;
  font-size: 20px
}

video[data-v-1523d6cc]::-webkit-media-controls-enclosure {
  overflow: hidden
}

video[data-v-1523d6cc]::-webkit-media-controls-panel {
  width: calc(100% + 30px)
}

.buy_wrap[data-v-1523d6cc] {
  display: flex;
  justify-content: space-between
}

.buy_wrap .small[data-v-1523d6cc] {
  height: 56px!important;
  font-size: 18px!important
}

.buy_wrap .download-btn[data-v-1523d6cc] {
  width: 334px;
  height: 60px;
  background: linear-gradient(180deg,#fb9e0a,#fe5200);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 28px
}

.buy_wrap .download-btn[data-v-1523d6cc]:hover {
  background: linear-gradient(180deg,#ffa71a,#fd6118)
}

.buy_wrap .downloading[data-v-1523d6cc] {
  pointer-events: none;
  opacity: .5
}

.buy_wrap .black-btn[data-v-1523d6cc] {
  background: #fdc87f;
  color: #7d4733
}

.buy_wrap .black-btn[data-v-1523d6cc]:hover {
  background: #fbc880
}

.buy_wrap .shopping-cart-btn[data-v-1523d6cc] {
  width: 83px;
  height: 60px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #ededed;
  margin-left: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden
}

.buy_wrap .shopping-cart-btn:hover svg .a1[data-v-1523d6cc] {
  stroke: #e42339
}

.buy_wrap .shopping-cart-btn:hover svg .a2[data-v-1523d6cc] {
  fill: #e42339
}

.pkTypeTabs[data-v-1523d6cc] {
  margin-bottom: 20px
}

.pkTypeTabs .tabItem[data-v-1523d6cc] {
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  line-height: 22px;
  position: relative
}

.pkTypeTabs .tabItem[data-v-1523d6cc]:hover {
  color: #fe024b
}

.pkTypeTabs .tabItem .tip[data-v-1523d6cc] {
  position: absolute;
  top: -22px;
  left: 24px
}

.pkTypeTabs .tabItem+.tabItem[data-v-1523d6cc] {
  margin-left: 32px
}

.pkTypeTabs .activePkTabType[data-v-1523d6cc] {
  font-weight: 600;
  color: #fe024b;
  height: 22px
}

.pkTypeTabs .activePkTabType .slideLine[data-v-1523d6cc] {
  width: 30px;
  height: 5px;
  border-radius: 100px;
  background: #fd2840;
  margin: 4px auto 0
}


.question-icon[data-v-1523d6cc] {
  margin-left: 4px;
  cursor: pointer
}


.photo-preview[data-v-3327522a] {
  width: 65%;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 15px 28px 15px;
  box-sizing: border-box;
  border-radius: 4px
}
/*.photo-preview img{
  width: 9.5rem;
  height 6.4rem;
}*/
.photo-preview .btn-wrapper[data-v-3327522a] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px
}

.photo-preview .btn-wrapper .report-btn[data-v-3327522a] {
  display: flex;
  font-size: 14px;
  cursor: pointer
}


.photo-preview .btn-wrapper .report-btn[data-v-3327522a]:hover {
  color: #fe024b
}

.photo-preview .btn-wrapper .report-btn:hover svg .bg[data-v-3327522a] {
  fill: #fe024b
}

.photo-preview .btn-wrapper .action-btn[data-v-3327522a] {
  display: flex
}

.photo-preview .btn-wrapper .action-btn .btn[data-v-3327522a]:hover {
  color: #fe024b
}
.photo-preview .btn-wrapper .action-btn .btn[data-v-3327522a] {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  line-height: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 30px
}

.photo-preview .btn-wrapper .action-btn .btn img[data-v-3327522a] {
  margin-right: 3px
}

.photo-preview .btn-wrapper .action-btn .act[data-v-3327522a] {
  color: #fe024b
}

.photo-preview .title-wrapper[data-v-3327522a] {
  display: flex;
  margin-bottom: 14px
}

.photo-preview .title-wrapper .prefix-title[data-v-3327522a] {
  align-items: center;
  margin-right: 7px;
  width: 18px;
  height: 25px
}

.photo-preview .title-wrapper .suffix-title[data-v-3327522a] {
  margin: 0;
  width: 570px;
  font-size: 18px;
  font-weight: 400;
  color: #000;
  user-select :text;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.photo-preview .author-text[data-v-3327522a] {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 25px;
  color: #666
}

.photo-preview .author-text a[data-v-3327522a] {
  color: #666
}

.photo-preview .img-wrapper[data-v-3327522a] {
  height: 525px;
  display: flex;
  align-items: center;
  background-color: #f5f6f8;
  position: relative;
  border-radius: 4px;
  overflow: hidden
}

.photo-preview .img-wrapper .img-mark[data-v-3327522a],.photo-preview .img-wrapper .img-preview[data-v-3327522a] {
  -o-object-fit: contain;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%
}

.photo-preview .img-wrapper .img-mark[data-v-3327522a] {
  position: absolute;
  top: 0;
  right: 0;
  transform: scale(.6)
}

.photo-preview .img-wrapper .video-preview[data-v-3327522a] {
  width: 100%;
  height: 100%
}

.photo-preview .fbd[data-v-3327522a] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 20
}
</style>



// WEBPACK FOOTER //
// src/components/Education/components/imageList/imageDetails.vue